"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.benefitsLayoutClasses = void 0;
var _mui = require("@ori-ui/mui");
const benefitsLayoutClasses = exports.benefitsLayoutClasses = (0, _mui.generateUtilityClasses)('ProductList', [
    'threeBenefitsRoot',
    'sixBenefitsRoot',
    'benefitBox',
    'innerRoot'
]);
